import { render, staticRenderFns } from "./TargetAndRewardValues.vue?vue&type=template&id=012f7bba&scoped=true&"
import script from "./TargetAndRewardValues.vue?vue&type=script&lang=js&"
export * from "./TargetAndRewardValues.vue?vue&type=script&lang=js&"
import style0 from "./TargetAndRewardValues.vue?vue&type=style&index=0&id=012f7bba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012f7bba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('012f7bba')) {
      api.createRecord('012f7bba', component.options)
    } else {
      api.reload('012f7bba', component.options)
    }
    module.hot.accept("./TargetAndRewardValues.vue?vue&type=template&id=012f7bba&scoped=true&", function () {
      api.rerender('012f7bba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Monthly/components/TargetAndRewardValues.vue"
export default component.exports